package com.havn.app.features.properties.domain

data class Property(
    val id: String,
    val agentId: String,
    val ownerAgentId: String? = null,
    val agencyId: String? = null,
    val assignedAgentId: String? = null,
    val title: String,
    val addressLine1: String,
    val addressLine2: String? = null,
    val city: String,
    val region: String,
    val postalCode: String,
    val country: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null,
    val askingPrice: Long,
    val bedrooms: Double? = null,
    val bathrooms: Double? = null,
    val interiorSqft: Int? = null,
    val status: PropertyStatus = PropertyStatus.Planned,
    val description: String? = null,
    val ownerContactId: String? = null,
    val ownerFirstName: String? = null,
    val ownerLastName: String? = null,
    val ownerEmail: String? = null,
    val ownerPhone: String? = null,
    val heroPhotoPath: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val photos: List<PropertyPhoto> = emptyList(),
    val stats: PropertyPerformanceStats = PropertyPerformanceStats()
) {
    val displayAddress: String
        get() = addressLine1

    val displayCity: String
        get() = listOf(city, region).filter { it.isNotBlank() }.joinToString(", ")
}

data class PropertyDraft(
    val title: String = "",
    val addressLine1: String = "",
    val addressLine2: String = "",
    val city: String = "",
    val region: String = "",
    val postalCode: String = "",
    val country: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null,
    val askingPrice: Long = 0,
    val bedrooms: Double? = null,
    val bathrooms: Double? = null,
    val interiorSqft: Int? = null,
    val status: PropertyStatus = PropertyStatus.Planned,
    val description: String = "",
    val ownerContactId: String? = null,
    val ownerFirstName: String = "",
    val ownerLastName: String = "",
    val ownerEmail: String = "",
    val ownerPhone: String = ""
)

data class PropertyAssignment(
    val agentId: String
)

enum class PropertyStatus(val label: String, val databaseValue: String) {
    Active("Active", "active"),
    Planned("Planned", "draft"),
    Archived("Archived", "archived");

    companion object {
        fun fromDatabase(value: String?): PropertyStatus = when (value) {
            "active" -> Active
            "archived" -> Archived
            else -> Planned
        }
    }
}

data class PropertyPhoto(
    val id: String,
    val propertyId: String,
    val storagePath: String,
    val altText: String? = null,
    val sortOrder: Int = 0,
    val isHero: Boolean = false,
    val thumbnailDataUrl: String? = null,
    val listThumbnailDataUrl: String? = null,
    val thumbnailWidth: Int? = null,
    val thumbnailHeight: Int? = null,
    val contentType: String? = null,
    val sizeBytes: Long? = null,
    val createdAt: String? = null
)

data class PropertyPerformanceStats(
    val totalVisitors: Int = 0,
    val hotLeads: Int = 0,
    val followUpsSent: Int = 0,
    val openingCount: Int = 0,
    val conversionRate: Double = 0.0
)

data class PropertyPhotoUpload(
    val fileName: String,
    val bytes: ByteArray,
    val contentType: String,
    val altText: String? = null,
    val isHero: Boolean = false,
    val thumbnailDataUrl: String? = null,
    val thumbnailWidth: Int? = null,
    val thumbnailHeight: Int? = null,
    val listThumbnailDataUrl: String? = null,
    val listThumbnailWidth: Int? = null,
    val listThumbnailHeight: Int? = null
)
